export default {
    data() {
        return {
            donationType: '',
            visibleTotals: {
                payOnline: [
                    'pay_at_pickup',
                    'pay_online',
                    'pay_online_with_donation',
                    'pay_online_without_extras',
                    'insurance_online',
                    'extras_online',
                    'green_heart_donation',
                    'total',
                ],
                payOnlineUS: [
                    'total',
                    'base_rental',
                    'extras_on_arrival',
                    'extras_online',
                    'green_heart_donation',
                    'upgrades',
                    'total_fees',
                ],
                payOnArrival: [
                    'pay_online',
                    'pay_online_without_extras',
                    'insurance_online',
                    'green_heart_donation',
                    'pay_on_arrival',
                    'pay_on_arrival_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'total',
                ],
                prepaidToPayOnArrival: [
                    'pay_at_pickup',
                    'green_heart_donation',
                    'pay_on_arrival',
                    'pay_on_arrival_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'total',
                ],
                editingExcludes: [
                    'green_heart_donation',
                ],
            },
        };
    },

    computed: Object.assign({
        location() {
            return typeof this.userLocation !== 'undefined'
            && (Object.keys(this.userLocation).length > 0 ? this.userLocation.countryCode : 'GB');
        },
        listType() {
            const listTypeByLocation = (this.location === 'US' || this.totals.base_rental !== 0) && this.quote?.us_location ? 'payOnlineUS' : 'payOnline';

            if (this.quote.is_poa_only) {
                return 'payOnArrival';
            }

            if (this.quote.is_poa && !this.globals.isUsavePPAndPoaJourney(this.quote)) {
                return 'prepaidToPayOnArrival';
            }

            return listTypeByLocation;
        },
        sortedTotals() {
            const ordered = {};

            Object.keys(this.totals)
                .sort((a, b) => {
                    return this.visibleTotals[this.listType].indexOf(a) - this.visibleTotals[this.listType].indexOf(b);
                })
                .forEach(key => {
                    ordered[key] = this.totals[key];
                });

            return ordered;
        },
        prePaid() {
            return this.quote.payment_type === 'PP';
        },
        priceIsConverted() {
            return this.quote.currency !== this.selectedCurrency.code;
        },
    }),

    methods: {
        displayTotal(key, modifying) {
            let display = this.visibleTotals[this.listType].includes(key) &&
                (this.totals[key] !== 0 ||
                    (modifying && !this.visibleTotals['editingExcludes'].includes(key)) ||
                    ((key == 'extras_online' || key == 'extras_on_arrival') && this.selectedExtras?.length > 0));

            return display;
        },
        isSubItem(key) {
            if (this.prePaid) {
                // return ['insurance_online', 'extras_online', 'pay_online_without_extras'].indexOf(key) > -1;
                return ['insurance_online', 'extras_online'].indexOf(key) > -1;
            }

            return (
                [
                    'insurance_online',
                    'extras_online',
                    // 'pay_online_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'pay_on_arrival_without_extras',
                ].indexOf(key) > -1
            );
        },
    },
};
